import { Type, Static } from '@sinclair/typebox'

import { SeasonTypeTB } from './report_shared'


export const IntegrationAgriwebbTB = Type.Object({
  id: Type.String(), // uuid
  userId: Type.Optional(Type.String()), // historical from farm app
  orgId: Type.String(), // N.B. technically optional in db, but required from new-ui onwards
  allowedFarmIds: Type.Array(Type.String()),
})
export type IntegrationAgriwebbT = Static<typeof IntegrationAgriwebbTB>

export const AgriwebbQuarterTB = Type.Object({
  id: SeasonTypeTB,
  startDate: Type.Any(), // Dayjs object
  endDate: Type.Any() // Dayjs object
})
export type AgriwebbQuarterT = Static<typeof AgriwebbQuarterTB>

export const AgriwebbFarmTB = Type.Object({
  id: Type.String(), // uuid
  name: Type.String()
})
export type AgriwebbFarmT = Static<typeof AgriwebbFarmTB>

export const AgriwebbAnimalUnitTB = Type.Object({
  unit: Type.String(),
  value: Type.Number()
})
export type AgriwebbAnimalUnitT = Static<typeof AgriwebbAnimalUnitTB>

export const AgriwebbAgeClassCattleTypeCalfTB = Type.Literal('calf')
export const AgriwebbAgeClassCattleTypeHeiferCalfTB = Type.Literal('heifer_calf')
export const AgriwebbAgeClassCattleTypeSteerCalfTB = Type.Literal('steer_calf')
export const AgriwebbAgeClassCattleTypeBullCalfTB = Type.Literal('bull_calf')
export const AgriwebbAgeClassCattleTypeNonBreedingBullCalfTB = Type.Literal('non_breeding_bull_calf')
export const AgriwebbAgeClassCattleTypeWeanerTB = Type.Literal('weaner')
export const AgriwebbAgeClassCattleTypeHeiferWeanerTB = Type.Literal('heifer_weaner')
export const AgriwebbAgeClassCattleTypeSteerWeanerTB = Type.Literal('steer_weaner')
export const AgriwebbAgeClassCattleTypeBullWeanerTB = Type.Literal('bull_weaner')
export const AgriwebbAgeClassCattleTypeNonBreedingBullWeanerTB = Type.Literal('non_breeding_bull_weaner')
export const AgriwebbAgeClassCattleTypeYearlingTB = Type.Literal('yearling')
export const AgriwebbAgeClassCattleTypeHeiferTB = Type.Literal('heifer')
export const AgriwebbAgeClassCattleTypeSpayedHeiferTB = Type.Literal('spayed_heifer')
export const AgriwebbAgeClassCattleTypeCowTB = Type.Literal('cow')
export const AgriwebbAgeClassCattleTypeSpayedCowTB = Type.Literal('spayed_cow')
export const AgriwebbAgeClassCattleTypeSteerTB = Type.Literal('steer')
export const AgriwebbAgeClassCattleTypeBullTB = Type.Literal('bull')
export const AgriwebbAgeClassCattleTypeNonBreedingBullTB = Type.Literal('non_breeding_bull')
export const AgriwebbAgeClassCattleTypeNonBreedingMatureBullTB = Type.Literal('non_breeding_mature_bull')

export const AgriwebbAgeClassCattleTypeTB = Type.Union([
  AgriwebbAgeClassCattleTypeCalfTB,
  AgriwebbAgeClassCattleTypeHeiferCalfTB,
  AgriwebbAgeClassCattleTypeSteerCalfTB,
  AgriwebbAgeClassCattleTypeBullCalfTB,
  AgriwebbAgeClassCattleTypeNonBreedingBullCalfTB,
  AgriwebbAgeClassCattleTypeWeanerTB,
  AgriwebbAgeClassCattleTypeHeiferWeanerTB,
  AgriwebbAgeClassCattleTypeSteerWeanerTB,
  AgriwebbAgeClassCattleTypeBullWeanerTB,
  AgriwebbAgeClassCattleTypeNonBreedingBullWeanerTB,
  AgriwebbAgeClassCattleTypeYearlingTB,
  AgriwebbAgeClassCattleTypeHeiferTB,
  AgriwebbAgeClassCattleTypeSpayedHeiferTB,
  AgriwebbAgeClassCattleTypeCowTB,
  AgriwebbAgeClassCattleTypeSpayedCowTB,
  AgriwebbAgeClassCattleTypeSteerTB,
  AgriwebbAgeClassCattleTypeBullTB,
  AgriwebbAgeClassCattleTypeNonBreedingBullTB,
  AgriwebbAgeClassCattleTypeNonBreedingMatureBullTB,
])
export type AgriwebbAgeClassCattleTypeT = Static<typeof AgriwebbAgeClassCattleTypeTB>

export const AgriwebbAgeClassSheepTypeLambTB = Type.Literal('lamb')
export const AgriwebbAgeClassSheepTypeEweLambTB = Type.Literal('ewe_lamb')
export const AgriwebbAgeClassSheepTypeRamLambTB = Type.Literal('ram_lamb')
export const AgriwebbAgeClassSheepTypeWetherLambTB = Type.Literal('wether_lamb')
export const AgriwebbAgeClassSheepTypeEweWeanerTB = Type.Literal('ewe_weaner')
export const AgriwebbAgeClassSheepTypeRamWeanerTB = Type.Literal('ram_weaner')
export const AgriwebbAgeClassSheepTypeWetherWeanerTB = Type.Literal('wether_weaner')
export const AgriwebbAgeClassSheepTypeHoggetTB = Type.Literal('hogget')
export const AgriwebbAgeClassSheepTypeEweHoggetTB = Type.Literal('ewe_hogget')
export const AgriwebbAgeClassSheepTypeRamHoggetTB = Type.Literal('ram_hogget')
export const AgriwebbAgeClassSheepTypeWetherHoggetTB = Type.Literal('wether_hogget')
export const AgriwebbAgeClassSheepTypeMaidenEweTB = Type.Literal('maiden_ewe')
export const AgriwebbAgeClassSheepTypeEweTB = Type.Literal('ewe')
export const AgriwebbAgeClassSheepTypeWetherTB = Type.Literal('wether')
export const AgriwebbAgeClassSheepTypeRamTB = Type.Literal('ram')

export const AgriwebbAgeClassSheepTypeTB = Type.Union([
  AgriwebbAgeClassSheepTypeLambTB,
  AgriwebbAgeClassSheepTypeEweLambTB,
  AgriwebbAgeClassSheepTypeRamLambTB,
  AgriwebbAgeClassSheepTypeWetherLambTB,
  AgriwebbAgeClassSheepTypeEweWeanerTB,
  AgriwebbAgeClassSheepTypeRamWeanerTB,
  AgriwebbAgeClassSheepTypeWetherWeanerTB,
  AgriwebbAgeClassSheepTypeHoggetTB,
  AgriwebbAgeClassSheepTypeEweHoggetTB,
  AgriwebbAgeClassSheepTypeRamHoggetTB,
  AgriwebbAgeClassSheepTypeWetherHoggetTB,
  AgriwebbAgeClassSheepTypeMaidenEweTB,
  AgriwebbAgeClassSheepTypeEweTB,
  AgriwebbAgeClassSheepTypeWetherTB,
  AgriwebbAgeClassSheepTypeRamTB,
])
export type AgriwebbAgeClassSheepTypeT = Static<typeof AgriwebbAgeClassSheepTypeTB>

export const AgriwebbMobAgeClassCattleTypeCalvesTB = Type.Literal('Calves')
export const AgriwebbMobAgeClassCattleTypeHeiferCalvesTB = Type.Literal('Heifer Calves')
export const AgriwebbMobAgeClassCattleTypeSteerCalvesTB = Type.Literal('Steer Calves')
export const AgriwebbMobAgeClassCattleTypeBullCalvesTB = Type.Literal('Bull Calves')
export const AgriwebbMobAgeClassCattleTypeWeanersTB = Type.Literal('Weaners')
export const AgriwebbMobAgeClassCattleTypeHeiferWeanersTB = Type.Literal('Heifer Weaners')
export const AgriwebbMobAgeClassCattleTypeSteerWeanersTB = Type.Literal('Steer Weaners')
export const AgriwebbMobAgeClassCattleTypeBullWeanersTB = Type.Literal('Bull Weaners')
export const AgriwebbMobAgeClassCattleTypeHeifersTB = Type.Literal('Heifers')
export const AgriwebbMobAgeClassCattleTypeCowsTB = Type.Literal('Cows')
export const AgriwebbMobAgeClassCattleTypeSteersTB = Type.Literal('Steers')
export const AgriwebbMobAgeClassCattleTypeBullsTB = Type.Literal('Bulls')

export const AgriwebbMobAgeClassCattleTypeTB  = Type.Union([
  AgriwebbMobAgeClassCattleTypeCalvesTB,
  AgriwebbMobAgeClassCattleTypeHeiferCalvesTB,
  AgriwebbMobAgeClassCattleTypeSteerCalvesTB,
  AgriwebbMobAgeClassCattleTypeBullCalvesTB,
  AgriwebbMobAgeClassCattleTypeWeanersTB,
  AgriwebbMobAgeClassCattleTypeHeiferWeanersTB,
  AgriwebbMobAgeClassCattleTypeSteerWeanersTB,
  AgriwebbMobAgeClassCattleTypeBullWeanersTB,
  AgriwebbMobAgeClassCattleTypeHeifersTB,
  AgriwebbMobAgeClassCattleTypeCowsTB,
  AgriwebbMobAgeClassCattleTypeSteersTB,
  AgriwebbMobAgeClassCattleTypeBullsTB,
])
export type AgriwebbMobAgeClassCattleTypeT = Static<typeof AgriwebbMobAgeClassCattleTypeTB>

export const AgriwebbMobAgeClassSheepTypeLambsTB = Type.Literal('Lambs')
export const AgriwebbMobAgeClassSheepTypeEweLambsTB = Type.Literal('Ewe Lambs')
export const AgriwebbMobAgeClassSheepTypeRamLambsTB = Type.Literal('Ram Lambs')
export const AgriwebbMobAgeClassSheepTypeWetherLambsTB = Type.Literal('Wether Lambs')
export const AgriwebbMobAgeClassSheepTypeEweWeanersTB = Type.Literal('Ewe Weaners')
export const AgriwebbMobAgeClassSheepTypeRamWeanersTB = Type.Literal('Ram Weaners')
export const AgriwebbMobAgeClassSheepTypeWetherWeanersTB = Type.Literal('Wether Weaners')
export const AgriwebbMobAgeClassSheepTypeHoggetsTB = Type.Literal('Hoggets')
export const AgriwebbMobAgeClassSheepTypeEweHoggetsTB = Type.Literal('Ewe Hoggets')
export const AgriwebbMobAgeClassSheepTypeRamHoggetsTB = Type.Literal('Ram Hoggets')
export const AgriwebbMobAgeClassSheepTypeWetherHoggetsTB = Type.Literal('Wether Hoggets')
export const AgriwebbMobAgeClassSheepTypeEwesTB = Type.Literal('Ewes')
export const AgriwebbMobAgeClassSheepTypeWethersTB = Type.Literal('Wethers')
export const AgriwebbMobAgeClassSheepTypeRamsTB = Type.Literal('Rams')

export const AgriwebbMobAgeClassSheepTypeTB = Type.Union([
  AgriwebbMobAgeClassSheepTypeLambsTB,
  AgriwebbMobAgeClassSheepTypeEweLambsTB,
  AgriwebbMobAgeClassSheepTypeRamLambsTB,
  AgriwebbMobAgeClassSheepTypeWetherLambsTB,
  AgriwebbMobAgeClassSheepTypeEweWeanersTB,
  AgriwebbMobAgeClassSheepTypeRamWeanersTB,
  AgriwebbMobAgeClassSheepTypeWetherWeanersTB,
  AgriwebbMobAgeClassSheepTypeHoggetsTB,
  AgriwebbMobAgeClassSheepTypeEweHoggetsTB,
  AgriwebbMobAgeClassSheepTypeRamHoggetsTB,
  AgriwebbMobAgeClassSheepTypeWetherHoggetsTB,
  AgriwebbMobAgeClassSheepTypeEwesTB,
  AgriwebbMobAgeClassSheepTypeWethersTB,
  AgriwebbMobAgeClassSheepTypeRamsTB,
])
export type AgriwebbMobAgeClassSheepTypeT = Static<typeof AgriwebbMobAgeClassSheepTypeTB>

// see getUsersAnimalsNew() in controllers/agriwebb.ts
export const AgriwebbAnimalTB = Type.Object({
  animalId: Type.String(),
  ageClass: Type.Union([AgriwebbAgeClassCattleTypeTB, AgriwebbAgeClassSheepTypeTB]),
  characteristics: Type.Object({
    birthDate: Type.Number(),
    birthYear: Type.Number(),
    sex: Type.Union([Type.Literal('Male'), Type.Literal('Female'), Type.Literal('Unspecified')])
  }),
  state: Type.Object({
    fertilityStatus: Type.Union([Type.Literal('Unknown'), Type.Literal('Fertile'), Type.Literal('Infertile'), Type.Literal('Neutered'), Type.Literal('Cryptorchid'), Type.Literal('NonBreeding')]),
    hasHadOffspring: Type.Boolean(),
    weaned: Type.Boolean(),
    weights: Type.Object({
      assumedAverageDailyGain: Type.Union([Type.Null(), AgriwebbAnimalUnitTB]),
      estimatedWeight: Type.Union([Type.Null(), AgriwebbAnimalUnitTB]),
      liveAverageDailyGain: Type.Union([Type.Null(), AgriwebbAnimalUnitTB]),
      liveWeight: Type.Union([Type.Null(), AgriwebbAnimalUnitTB]),
      overallAverageDailyGain: Type.Union([Type.Null(), AgriwebbAnimalUnitTB]),
    }),
    animalUnits: AgriwebbAnimalUnitTB
  })
})
export type AgriwebbAnimalT = Static<typeof AgriwebbAnimalTB>

export const AgriwebbSeasonalAnimalResultTB = Type.Object({
  seasonId: Type.String(),
  result: Type.Optional(Type.Array(AgriwebbAnimalTB))
})
export type AgriwebbSeasonalAnimalResultT = Static<typeof AgriwebbSeasonalAnimalResultTB>

export const AgriwebbSeasonalMobResultTB = Type.Record(
  Type.Union([Type.Literal('spring'), Type.Literal('summer'), Type.Literal('autumn'), Type.Literal('winter')]),
  Type.String()
)
export type AgriwebbSeasonalMobResultT = Static<typeof AgriwebbSeasonalMobResultTB>

export const AgriwebbMobRecordTB = Type.Object({
  "Age Class": Type.Union([
    AgriwebbMobAgeClassCattleTypeTB,
    AgriwebbMobAgeClassSheepTypeTB,

    // New Reconciliation Report includes individuals
    AgriwebbAgeClassSheepTypeTB,
    AgriwebbAgeClassCattleTypeTB
  ]), // "Steers"
  "Aged In": Type.String(), // "0"
  "Aged Out": Type.String(), // "0"
  "Birth Year": Type.String(), // "2021"
  "Bred": Type.String(), // "0"
  "Breed": Type.String(), // "Angus"
  "Breed Changed In": Type.String(), // "0"
  "Breed Changed Out": Type.String(), // "0"
  "Closing": Type.String(), // "100"
  "Closing Load": Type.String(), // "950"
  "Closing Weight": Type.String(), // "52000"
  "Closing Weight_1": Type.String(), // "52000"
  "Condemned": Type.String(), // "0"
  "Deaths": Type.String(), // "0"
  "Discrepancies": Type.String(), // "0"
  "Management Tag": Type.String(), // ""
  "Management Tags Changed In": Type.String(), // "0"
  "Management Tags Changed Out": Type.String(), // "0"
  "Mob": Type.String(), // "Angus Steers"
  "Mob Description": Type.String(), // ""
  "Moved In": Type.String(), // "0"
  "Moved Out": Type.String(), // "0"
  "Opening": Type.String(), // "100"
  "Opening Load": Type.String(), // "950"
  "Opening Weight": Type.String(), // "52000"
  "Opening Weight_1": Type.String(), // "52000"
  "Paddock": Type.String(), // "Paddock 1"
  "Purchased": Type.String(), // "0"
  "Recounts": Type.String(), // "0"
  "Sold": Type.String(), // "0"
  "Species": Type.String(), // "Cattle"
  "Tag Colour": Type.String(), // "Orange"
  "Tag Colour Changed In": Type.String(), // "0"
  "Tag Colour Changed Out": Type.String(), // "0"
  "Transferred Off": Type.String(), // "0"
  "Transferred On": Type.String() // "0"
})
export type AgriwebbMobRecordT = Static<typeof AgriwebbMobRecordTB>
